import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { STRIPE_SECRET_LIVE_KEY } from "lib/global";
import CreditCardDetail from "./CreditCardDetail";

const stripePromise = loadStripe(STRIPE_SECRET_LIVE_KEY);

export default function PaymentCardForm(props) {
  return (
    <div className="pt-4">
      <Elements stripe={stripePromise}>
        <CreditCardDetail {...props} />
      </Elements>
    </div>
  );
}
